import React from 'react'
import { CSVLink } from 'react-csv'
import { ListGroup, ListGroupItem, Button } from 'reactstrap'
import PropTypes from 'prop-types'

/**
 * Display a list of all of the username CSVs that can
 * be downloaded
 * @param {object} props
 */
function CSVList ({
  csvData, 
  loadingComplete, 
  schoolName
}) {
  if (!loadingComplete || !csvData) return null
  return (
    <ListGroup>
      {csvData.map(({ data, dateUploaded, dataType }, n) => {
        const date = (new Date(dateUploaded)).toLocaleDateString()
        const label = dataType === 'students' ? 'Students' : 'Teachers'
        return <ListGroupItem key={'csvList' + n}>
          {`${label}: ${date} `}
          <CSVLink
            data={data}
            filename={`${schoolName} ${label} ${dateUploaded}.csv`}
          >
            <Button>Download</Button>
          </CSVLink>
        </ListGroupItem>
      })}
    </ListGroup>
  )
}

const { array, bool, string } = PropTypes
CSVList.propTypes = {
  csvData: array.isRequired,
  loadingComplete: bool.isRequired,
  schoolName: string.isRequired,
}
export default CSVList


// WEBPACK FOOTER //
// ./src/components/Assessment/UploadCSVComponents/CSVList.js